module.exports = __webpack_public_path__ + "img/ring_y_o_1_null@3x.3fc11618.png";